export const environment = {
  production: true,
  apiKey: '07a77bc29bab4769804f8c0b85dc219c'
};